import InventarioTI from "../Modulos/InventarioTI/InventarioTI";

export default function InventarioTIRoute() {
  return <InventarioTI />;
}

